<script lang="ts">
    import { onDestroy } from "svelte";
    import { t } from "$lib/i18n/translations";
    import { hapticSwitch } from "$lib/haptics";
    import { savingHandler } from "$lib/api/saving-handler";
    import { downloadButtonState } from "$lib/state/omnibox";

    import type { CobaltDownloadButtonState } from "$lib/types/omnibox";
    import { killDialog } from "$lib/state/dialogs";

    export let url: string;
    export let disabled = false;
    export let loading = false;
    export let className = "";

    $: buttonText = $t("save.download");
    $: buttonAltText = $t("save.download");

     type DownloadButtonState = "idle" | "think" | "check" | "done" | "error";
    const unsubscribe = downloadButtonState.subscribe(
        (state: CobaltDownloadButtonState) => {
            disabled = state !== "idle";
            loading = state === "think" || state === "check";
            const final: DownloadButtonState[] = ["done", "error"];
            if (final.includes(state)) {
                killDialog()
                setTimeout(() => downloadButtonState.set("idle"), 1500);
            }
        }
    );

    onDestroy(() => unsubscribe());
</script>

<button
    id="download-button"
    {disabled}
    on:click={() => {
        hapticSwitch();
        savingHandler({ url });
    }}
    aria-label={buttonAltText}
    class={className}
>
    <span class="text-[26px] max-mobile:text-[18px]">{buttonText}</span>
</button>

<style>
    #download-button {
        width: 230px;
        height: 64px;
        border-radius: 32px;
        background: #000000;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        color: #fff;
        margin-right: 4px;
    }

</style>
